import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import CollectionsBootstrap from 'modules/one_on_ones/lib/CollectionsBootstrap'

import { hasAccess } from '../lib/accessHelpers'

const Container = () => {
  return (
    <AuthorizeUser authorizeFn={() => hasAccess()}>
      <Outlet
        context={{
          loading: false,
        }}
      />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
